import { IJobResponse, JobType } from '@kcftech/prometheus-client';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export type RunSetupToolJobRequest = Readonly<{
    /**
     * The type of setup tool to be run
     */
    type: JobType;
    /**
     * The file to be uploaded
     */
    template: File;
    /**
     * The location id
     */
    locationId: string;
}>;

type JobUploadErrors = Readonly<{
    /** The error messages */
    Errors: Record<string, string>;
    /** The HTTP status code of the request */
    StatusCode: number;
}>;

// The mutation options object type
type UseSetupToolTemplateUploadOptions = UseMutationOptions<
    IJobResponse,
    JobUploadErrors,
    RunSetupToolJobRequest
>;

export function useSetupToolTemplateUpload(options: UseSetupToolTemplateUploadOptions) {
    return useMutation<IJobResponse, JobUploadErrors, RunSetupToolJobRequest>({
        meta: { name: 'setup-tool-template-upload' },
        mutationFn: ({ type, template, locationId }: RunSetupToolJobRequest) =>
            sdClient.runSetupToolJob({
                jobType: type,
                locationId,
                file: {
                    data: template,
                    fileName: template.name,
                },
            }),

        ...options,
    });
}
